import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Box from "../../../components/Box";
import { Helpers } from "../../../helpers/Helpers";
import { KTCard } from "../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../_metronic/helpers/components/KTCardBody";
import Content from "../../../_metronic/layout/components/content/Content";
import { ToolbarWrapper } from "../../../_metronic/layout/components/toolbar";
import { PageTitle } from "../../../_metronic/layout/core";
import { useNavigate, useSearchParams } from "react-router-dom";
import { storeActivityIndicator } from "../../../redux/reducers/authSlice";
import toast from "react-hot-toast";
import CustomSingleSelect, { CustomSingleSelectModel } from "../../../components/CustomSingleSelect";
import { ConstantService } from "../../../services/ConstantService";
import CustomTextInput from "../../../components/CustomTextInput";
import { useMask } from "@react-input/mask";
import CustomNumberInput from "../../../components/CustomNumberInput";
import { GsmCardStatusEnum, GsmCardTypeEnum, GsmOperatorEnum, GsmStatusEnum } from "../../../models/common/Enums";
import { GetConstantListResponse } from "../../../models/response/constant/GetConstantListResponse";
import moment from "moment";
import { AddGsmStockRequest } from "../../../models/request/gsmStock/AddGsmStockRequest";
import { GsmStockService } from "../../../services/GsmStockService";
import { AddGsmStockResponse } from "../../../models/response/gsmStock/AddGsmStockResponse";
import { GetGsmStockByIdResponse } from "../../../models/response/gsmStock/GetGsmStockByIdResponse";

const GsmStockAdd = () => {
    const navigate = useNavigate();
    const pageName = "Genel Tanımlamalar > GSM Stok Tanımları"
    const [searchParams, setSearchParams] = useSearchParams();
    const dispatch = useDispatch();
    const phoneRef = useMask({ mask: '(___) ___-__-__', replacement: { _: /\d/ } });

    const [gsmStockId, setGsmStockId] = useState<string | undefined>(undefined);
    const [refNo, setRefNo] = useState<string | undefined>(undefined);
    const [selectedGsmOperator, setSelectedGsmOperator] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [deliveryDate, setDeliveryDate] = useState<string | undefined>(moment().format('YYYY-MM-DD'));
    const [selectedGsmStatus, setSelectedGsmStatus] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedGsmCardType, setSelectedGsmCardType] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [agreementStartDate, setAgreementStartDate] = useState<string | undefined>(undefined);
    const [phone, setPhone] = useState<string | undefined>(undefined);
    const [selectedGsmCardStatus, setSelectedGsmCardStatus] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [agreementEndDate, setAgreementEndDate] = useState<string | undefined>(undefined);
    const [iccid, setIccid] = useState<string | undefined>(undefined);

    useEffect(() => {
        var id = searchParams.get("id");
        getData(id);
    }, [])

    const getData = async (_id: string | undefined | null = undefined) => {
        try {
            dispatch(storeActivityIndicator(true));

            var id = _id ? _id : searchParams.get("id") ? searchParams.get("id") : undefined;

            if (id) {
                var response: GetGsmStockByIdResponse = await GsmStockService.getGsmStockById(id);

                if (!response.isSuccess) {
                    toast.error(response.message)
                    return;
                }

                setGsmStockId(response.data.gsmStockId);
                setRefNo(response.data.refNo);

                if (response.data.gsmOperatorId)
                    setSelectedGsmOperator({ label: response.data.gsmOperatorName, value: response.data.gsmOperatorId });

                setDeliveryDate(response.data.deliveryDate);

                if (response.data.gsmStatusId)
                    setSelectedGsmStatus({ label: response.data.gsmStatusName, value: response.data.gsmStatusId });

                if (response.data.gsmCardTypeId)
                    setSelectedGsmCardType({ label: response.data.gsmCardTypeName, value: response.data.gsmCardTypeId });

                setAgreementStartDate(response.data.agreementStartDate);
                setPhone(response.data.phone);

                if (response.data.gsmCardStatusId)
                    setSelectedGsmCardStatus({ label: response.data.gsmCardStatusName, value: response.data.gsmCardStatusId });

                setAgreementEndDate(response.data.agreementEndDate);
                setIccid(response.data.iccId);
            }
            else {
                var response2: GetConstantListResponse = await ConstantService.getConstantList('GSM_OPERATOR', undefined, GsmOperatorEnum.TURKCELL);

                if (!response2.isSuccess) {
                    toast.error(response2.message)
                    return;
                }

                setSelectedGsmOperator({ label: response2.data[0].value, value: response2.data[0].constantId, additionalValue1: response2.data[0].additionalValue1 });

                var response2: GetConstantListResponse = await ConstantService.getConstantList('GSM_STATUS', undefined, GsmStatusEnum.STOKTA);

                if (!response2.isSuccess) {
                    toast.error(response2.message)
                    return;
                }

                setSelectedGsmStatus({ label: response2.data[0].value, value: response2.data[0].constantId, additionalValue1: response2.data[0].additionalValue1 });

                var response2: GetConstantListResponse = await ConstantService.getConstantList('GSM_CARD_TYPE', undefined, GsmCardTypeEnum.M2M_HATTI);

                if (!response2.isSuccess) {
                    toast.error(response2.message)
                    return;
                }

                setSelectedGsmCardType({ label: response2.data[0].value, value: response2.data[0].constantId, additionalValue1: response2.data[0].additionalValue1 });

                var response2: GetConstantListResponse = await ConstantService.getConstantList('GSM_CARD_STATUS', undefined, GsmCardStatusEnum.AKTIF);

                if (!response2.isSuccess) {
                    toast.error(response2.message)
                    return;
                }

                setSelectedGsmCardStatus({ label: response2.data[0].value, value: response2.data[0].constantId, additionalValue1: response2.data[0].additionalValue1 });
            }
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }
    const saveGsmStock = async () => {
        try {
            dispatch(storeActivityIndicator(true));

            var obj: AddGsmStockRequest = {
                agreementEndDate: agreementEndDate,
                agreementStartDate: agreementStartDate,
                deliveryDate: deliveryDate,
                gsmCardStatusId: selectedGsmCardStatus?.value,
                gsmCardTypeId: selectedGsmCardType?.value,
                gsmOperatorId: selectedGsmOperator?.value,
                gsmStatusId: selectedGsmStatus?.value,
                gsmStockId: gsmStockId,
                iccId: iccid,
                phone: phone,
                refNo: refNo
            };

            var response: AddGsmStockResponse = await GsmStockService.addGsmStock(obj);

            if (!response.isSuccess) {
                toast.error(response.message);
                dispatch(storeActivityIndicator(false));
                return;
            }

            toast.success(response.message)

            dispatch(storeActivityIndicator(false));
            navigate(Helpers.getGoBackUrl())
        } catch (error: any) {
            toast.error(error);
            dispatch(storeActivityIndicator(false));
        }
    }

    return (
        <React.Fragment>
            <ToolbarWrapper filters={undefined} />

            <PageTitle breadcrumbs={[{
                title: pageName.split('>').slice(0, pageName.split('>').length - 1).join(' > ') + ' > ',
                isActive: false,
                path: ''
            }]}>{(pageName.split('>')[pageName.split('>').length - 1])}</PageTitle>

            <Box className="mb-10">
                <Content>
                    <div>
                        <KTCard className="ebbe-card">
                            <KTCardBody>
                                <h4 className="mb-10 text-black">Genel Bilgiler</h4>

                                <div className='row'>
                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Ref No</label>
                                        <CustomTextInput value={refNo} isDisabled />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Operatör</label>

                                        <CustomSingleSelect
                                            selectedValue={selectedGsmOperator}
                                            onChange={setSelectedGsmOperator}
                                            onMenuOpen={() => ConstantService.getConstantList('GSM_OPERATOR', undefined, undefined)}
                                            labelName='value'
                                            valueName='constantId'
                                        />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Teslim Alış Tarihi</label>
                                        <input style={{ border: '1px solid #F1F1F4' }} value={deliveryDate} onChange={(e) => setDeliveryDate(e.target.value)} type="date" className="form-control form-control-solid" />
                                    </div>
                                </div>

                                <div className='row mt-5'>
                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">SIM Kart Durumu</label>

                                        <CustomSingleSelect
                                            selectedValue={selectedGsmStatus}
                                            onChange={setSelectedGsmStatus}
                                            onMenuOpen={() => ConstantService.getConstantList('GSM_STATUS', undefined, undefined)}
                                            labelName='value'
                                            valueName='constantId'
                                        />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Hat Tipi</label>

                                        <CustomSingleSelect
                                            selectedValue={selectedGsmCardType}
                                            onChange={setSelectedGsmCardType}
                                            onMenuOpen={() => ConstantService.getConstantList('GSM_CARD_TYPE', undefined, undefined)}
                                            insertable={{
                                                onSubmit: { code: 'GSM_CARD_TYPE' }
                                            }}
                                            labelName='value'
                                            valueName='constantId'
                                        />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Söz. Başlangıç Tarihi</label>
                                        <input
                                            style={{ border: '1px solid #F1F1F4' }}
                                            value={agreementStartDate}
                                            onChange={(e) => {
                                                setAgreementStartDate(e.target.value)

                                                if (e?.target?.value && !Helpers.isEmpty(e?.target?.value)) {
                                                    setAgreementEndDate(moment(e?.target?.value, 'YYYY-MM-DD').add('years', 1).format('YYYY-MM-DD'));
                                                }
                                            }}
                                            type="date"
                                            className="form-control form-control-solid"
                                        />
                                    </div>
                                </div>

                                <div className="row mt-5">
                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Telefon No</label>
                                        <CustomTextInput _ref={phoneRef} value={phone} setValue={setPhone} />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Abonelik Durumu</label>

                                        <CustomSingleSelect
                                            selectedValue={selectedGsmCardStatus}
                                            onChange={setSelectedGsmCardStatus}
                                            onMenuOpen={() => ConstantService.getConstantList('GSM_CARD_STATUS', undefined, undefined)}
                                            insertable={{
                                                onSubmit: { code: 'GSM_CARD_STATUS' }
                                            }}
                                            labelName='value'
                                            valueName='constantId'
                                        />
                                    </div>

                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">Söz. Bitiş Tarihi</label>
                                        <input style={{ border: '1px solid #F1F1F4' }} value={agreementEndDate} onChange={(e) => setAgreementEndDate(e.target.value)} type="date" className="form-control form-control-solid" />
                                    </div>
                                </div>

                                <div className="row mt-5">
                                    <div className="col-md-4">
                                        <label htmlFor="exampleFormControlInput1" className="form-label">ICCID</label>
                                        <CustomNumberInput maxLength={18} value={iccid} setValue={setIccid} />
                                    </div>
                                </div>
                            </KTCardBody>
                        </KTCard>
                    </div>

                    <KTCard className="ebbe-card mt-10">
                        <KTCardBody>
                            <Box flexDirection="row" justifyContent="flex-end">
                                <Box mr="15px">

                                    <button className="btn btn-sm btn-light btn-active-light-primary" onClick={() => navigate(Helpers.getGoBackUrl())}>Geri</button>
                                </Box>
                                <Box>
                                    <button className="btn btn-primary btn-sm" onClick={saveGsmStock}>Kaydet</button>
                                </Box>
                            </Box>
                        </KTCardBody>
                    </KTCard>
                </Content>
            </Box>
        </React.Fragment>
    )
}

export default GsmStockAdd;